var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center poppins min-h-screen"},[_vm._t("default",[_vm._v("Please wait")]),_c('font-awesome-icon',{staticClass:"ml-2",attrs:{"icon":['fas', 'spinner'],"spin":""}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }